import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import DepartmentCard from "../Departments/component/departmentCard";
import GurugramForm from "../GurugramLab/gurugramForm";
import Facility from "../labDetail/component/Facility";
import Payment from "../labDetail/component/Payment";
import SeoAdd from "../Seo/SeoAdd";
import DoctorList from "./DoctorList";
import WhyOncqSection from "./WhyOncqSection";
import SendQueryModal from "../packageDetail/SendQueryModal";
import WhyOncq from "../../Home/component/WhyOncq";
import ImgSlider from "./ImgSlider";

const BengaluruLab = () => {
  const { t } = useTranslation();

  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [code, setCode] = useState<any>("");

  useEffect(() => {
    window?.scrollTo(0, 0);
    let intervalId = setTimeout(() => {
      handleModalOpen("Bengaluru Lab");
    }, 2000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleModalOpen = (code: any) => {
    setCode(code);
    setModalIsOpen(true);
  };

  return (
    <>
      <SeoAdd slug={ROUTE.BENGALURULAB} />
      <BreadCrumb page={t("bengaluru_lab")} data={{ slug: "", path: "" }} />
      <section className="bg-white section pt-3">
        <div className="container" id="section2">
          <div className="row">
            <div className="col-12">
              <div className="text-center">
                <img src={t("images.bg_lab.banner")} className="scale" alt="" />
              </div>
              <div className="headingmains text-center py-3">
                <h1 className="right aos-init pb-3 mt-sm-3 mt-lg-4">
                  {t("about_bengaluru_lab")}
                </h1>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <p className="text-center py-2">
                      {t("about_bengaluru_lab_info1")}
                    </p>
                    <p className="text-center py-2">
                      {t("about_bengaluru_lab_info2")}
                    </p>
                    <p className="text-center py-2">
                      {t("about_bengaluru_lab_info3")}
                    </p>
                    <p className="text-center py-2">
                      {t("about_bengaluru_lab_info4")}
                    </p>
                    <p className="text-center py-2">
                      {t("about_bengaluru_lab_info5")}
                    </p>
                  </div>
                  <div className="col-12 col-md-6 d-flex align-items-start justify-content-end">
                    <div className="w-100">
                      <GurugramForm pageSource="Bengaluru Lab" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white">
        <div className="container">
          <div className="btm_overview">
            <WhyOncqSection />
          
          </div>
          <DepartmentCard />
          {/* <div className="pb-4">
            <DoctorList />
          </div> */}
          <div className="pb-4 text-center headingmains">
            <div className="text-center py-3">
              <h3 className="right aos-init pb-3 mt-sm-3 mt-lg-4">
                {t("home_sample_collection")}
              </h3>
            </div>
            <div className="pb-3">
              <div className="calldt_lab">
                <a className="text" target="_blank" href="tel: +919663656262">
                  <img src="/assets/img/call.png" width="20px" height="20px" />
                  <span style={{ marginLeft: "10px" }}>+91 9663656262</span>
                </a>
                {/* <a
                  href={`https://wa.me/+918040917809`}
                  target="_blank"
                  style={{ marginLeft: "10px" }}
                >
                  <img
                    src="/assets/img/whatsapp.png"
                    width="20px"
                    height="20px"
                  />
                  <span style={{ marginLeft: "10px" }}>+91 8040917809</span>
                </a> */}
              </div>
              {/* <h3 className="right aos-init py-2 mt-3">
                                {t("laboratory_reference")}
                            </h3> */}
              <p className="text-center py-2 text_light">{t("company_name")}</p>
              <div className="text-center py-2">
                {t("address_bengaluru_lab")}
              </div>
              <div className="py-2">
                <a
                  href="https://goo.gl/maps/MSE3xYr77ZrGbQws9"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="viewMapLink"
                >
                  <span>{t("view_map")}</span>
                </a>
              </div>
            </div>
          </div>
          <section className="row">
            <div className="col-md-7 col-12">
              <Facility />
            </div>
            <div className="col-md-5 col-12">
              <Payment />
            </div>
          </section>
        </div>
      </section>
      <SendQueryModal
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
        test={false}
        code={code}
        lab={true}
      />
    </>
  );
};

export default BengaluruLab;
